import { Switch, useRouteMatch } from "react-router-dom";
import ProtectedRoute from "components/ProtectedRoutes";

import BCPL from "./BCPL";
import History from "./History";
import RequestLoan from "./RequestLoan";
import PaybackLoan from "./PaybackLoan";
import LoanDetails from "./LoanDetails";

const BCPLRoot = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <ProtectedRoute exact path={path} component={BCPL} />
      <ProtectedRoute exact path={`${path}/history`} component={History} />
      <ProtectedRoute exact path={`${path}/request`} component={RequestLoan} />
      <ProtectedRoute exact path={`${path}/payback`} component={PaybackLoan} />
      <ProtectedRoute
        exact
        path={`${path}/:id/payback`}
        component={PaybackLoan}
      />
      <ProtectedRoute
        exact
        path={`${path}/:id/details`}
        component={LoanDetails}
      />
    </Switch>
  );
};

export default BCPLRoot;
